module.exports = __webpack_public_path__ + "img/logo.9c8c3196.png";